import React, { useState } from 'react';
import ReactApexChart from 'react-apexcharts';
import { useTranslation } from '../../../../commons/useTranslasion';

interface BarChartSeries {
    name: string;
    data: number[];
    color?: string;
}

interface BarChartProps {
    categories: string[];
    series: BarChartSeries[];
    title?: string;
    height?: number;
    colors: string[];
}

const BarChart: React.FC<BarChartProps> = ({
    categories = [],
    series = [],
    title = '',
    height = 350,
    colors = []
}) => {
    const { translate } = useTranslation();
    if (!categories.length || !series.length) {
        return <div>{translate("noDataAvailable")}</div>;
    }

    const [state, setState] = useState({
        series: series.map(item => ({
            name: item.name,
            data: item.data || [],
            color: item.color
        })),
        options: {
            chart: {
                type: 'bar' as const,
                height: height
            },
            colors: colors,
            plotOptions: {
                bar: {
                    columnWidth: '45%',
                    distributed: true,
                }
            },
            dataLabels: {
                enabled: false
            },
            legend: {
                show: true,
                position: 'bottom' as const,
                horizontalAlign: 'center' as const,
                fontSize: '14px',
                markers: {
                    size: 12,
                    radius: 12,
                },
            },
            xaxis: {
                categories: categories,
                labels: {
                    style: {
                        colors: colors,
                        fontSize: '12px'
                    }
                }
            },
            yaxis: {
                title: {
                    text: title || undefined
                }
            },
            fill: {
                opacity: 1
            },
            tooltip: {
                y: {
                    formatter: function (val: number) {
                        return val.toString();
                    }
                }
            }
        }
    });

    return (
        <div>
            <div id="chart">
                <ReactApexChart 
                    options={state.options} 
                    series={state.series} 
                    type="bar" 
                    height={height} 
                />
            </div>
            <div id="html-dist"></div>
        </div>
    );
};

export default BarChart;